<div class="container">
  <div class="globeimg"></div>
</div>
<div class="container">
  <div class="coverage-header">
    <h1 class="coverage-header-title">
      {{ coverageTitle }}
    </h1>
    <p class="coverage-header-description">
      {{ coverageDescription }}
    </p>
  </div>

  <div class="explore-coverage-container">
    <div class="explore-coverage-container-section yellow-borders" [ngClass]="covered ? 'active-border' : ''">
      <div class="explore-coverage-container-section-covered-circle yellow-circle" [ngClass]="covered ? 'active-circle' : ''">
        <img src="{{imageBasePath}}/images/marketing-images/icon-check-blue.svg"
          alt="check"
          class="explore-coverage-container-section-covered-circle-icon">
        </div>

        <h3 class="explore-coverage-container-section-title">
          What's covered
        </h3>
        <button
          class=" btn explore-coverage-container-section-covered-btn"
          appAnalytics="click"
          eventCategory="NAVBAR"
          eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
          eventLabel= "{{ProductName}}- {{covered ? '(What\'s Covered) - Take a look' : '(What\'s Covered) - Show less'}}"
          (click)="hideShowCovered()"
          [ngClass]="covered ? 'active-btn' : ''">
          {{covered ? 'Show less' : 'Take a look'}}
        </button>
      </div>
      <div class="explore-coverage-container-section" [ngClass]="notCovered ? 'active-border' : ''">
        <div class="explore-coverage-container-section-not-covered-circle" [ngClass]="notCovered ? 'active-circle' : ''">
          <img src="{{imageBasePath}}/images/marketing-images/icon-x-blue.svg"
            alt="cross"
            class="explore-coverage-container-section-not-covered-circle-icon">
          </div>
          <h3 class="explore-coverage-container-section-title">
            What's not covered
          </h3>
          <button
            class="btn explore-coverage-container-section-not-covered-btn"
            appAnalytics="click"
            eventCategory="NAVBAR"
            eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
            eventLabel="{{ProductName }} - {{ notCovered ? '(What\'s Not Covered) - Take a look' : '(What\'s Not Covered) - Show less'}}"
            (click)="hideShowNotCovered()"
            [ngClass]="notCovered ? 'active-btn' : ''">
            {{notCovered ? 'Show less' : 'Take a look'}}
          </button>
        </div>
        @if (endorsementItems && endorsementItems.length > 0) {
          <div class="explore-coverage-container-section blue-borders" [ngClass]="endorsement ? 'active-border' : ''">
            <div class="explore-coverage-container-section-endorsement-circle blue-circle" [ngClass]="endorsement ? 'active-circle' : ''">
              <img src="{{imageBasePath}}/images/marketing-images/Icon_Endorsement.svg"
                alt="cross"
                class="explore-coverage-container-section-endorsement-circle-icon">
              </div>
              <h3 class="explore-coverage-container-section-title">
                What's covered by endorsement
              </h3>
              <button
                class="btn explore-coverage-container-section-endorsement-btn"
                appAnalytics="click"
                eventCategory="NAVBAR"
                eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
                eventLabel="{{ProductName }} - {{ endorsement ? '(What\'s Covered by Endorsement) - Take a look' : '(What\'s Covered by Endorsement) - Show less'}}"
                (click)="navigateTo()"
                [ngClass]="endorsement ? 'active-btn' : ''">
                Take a look
              </button>
            </div>
          }
        </div>
      </div>

      @if (covered) {
        <div class="container mobile-covered">
          <div class="covered-container">
            <img
              src="../../../assets/img/marketing/icons/not-covered-desktop.svg"
              alt="cross"
              class="covered-container-close"
              appAnalytics="click"
              eventCategory="NAVBAR"
              eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
              eventLabel= "{{ProductName }} {{'- (What\'s Covered) - Close'}}"
              (click)="hideCoverage()">
              <p class="covered-container-productname">{{ ProductName | uppercase}}</p>
              <h2 class="covered-container-title">
                What's covered
              </h2>
              <div class="table-header">
                <div class="table-header-title">Type of incident</div>
                <div class="table-header-title">How you’re covered</div>
              </div>
              <div class="flex-table-rows">
                @for (item of coveredItems; track item) {
                  <div class="group-row">
                    <div class="group-row-section">
                      <p class="text-info"><b>{{ item?.incidentName}}</b>
                      @if (item?.incidentSubName) {
                        <img  src="../../../assets/img/icons/icon-tooltip-blue.svg">
                      }</p>
                      @if (item?.incidentSubName) {
                        <p class="text-small">{{ item?.incidentSubName }}</p>
                      }
                    </div>
                    <div class="group-row-section">
                      <p class="text-info">{{ item?.textOne }}</p>
                      @if (item?.textOne) {
                        <p class="text-info">{{ item?.textTwo }}</p>
                      }
                      @if (item?.textThree) {
                        <p class="text-info">{{ item?.textThree }}</p>
                      }
                      @for (info of item.incidentInfo; track info) {
                        <p class="text-info">
                          {{ info.name }}
                        </p>
                      }
                      @for (subItem of item.subItems; track subItem) {
                        <ul class="sub-items">
                          <li class="sub-items-item">{{ subItem.name }}</li>
                        </ul>
                      }
                    </div>
                  </div>
                }
                @if (removedCoverageItems?.length > 0) {
                  <a
                    class="showmore-link"
                    appAnalytics="click"
                    eventCategory="NAVBAR"
                    eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
                    eventLabel= "{{ProductName }} {{'- (What\'s Covered) - See more'}}"
                    (click)="loadMoreCoveredItems()">
                    Show more
                  </a>
                }
              </div>
            </div>
          </div>
        }

        @if (notCovered) {
          <div class="container mobile-covered">
            <div class="covered-container" >
              <img
                src="../../../assets/img/marketing/icons/not-covered-desktop.svg"
                alt="cross"
                class="covered-container-close"
                appAnalytics="click"
                eventCategory="NAVBAR"
                eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
                eventLabel= "{{ProductName }} {{'- (What\'s Not Covered) - Close'}}"
                (click)="hideCoverage()">
                <p class="covered-container-productname">{{ ProductName | uppercase}}</p>
                <h2 class="covered-container-title">
                  What's not covered
                </h2>
                <div class="table-header">
                  <div class="table-header-title">Type of incident</div>
                  <div class="table-header-title">How you’re not covered</div>
                </div>
                <div class="flex-table-rows">
                  @for (item of notCoveredItems; track item) {
                    <div class="group-row">
                      <div class="group-row-section">
                        <p class="text-info"><b>{{ item?.incidentName}}</b></p>
                      </div>
                      <div class="group-row-section">
                        <p class="text-info">{{ item?.textOne }}</p>
                        @if (item?.textOne) {
                          <p class="text-info">{{ item?.textTwo }}</p>
                        }
                        @if (item?.textThree) {
                          <p class="text-info">{{ item?.textThree }}</p>
                        }
                        @for (info of item.incidentInfo; track info) {
                          <p class="text-info">
                            {{ info.name }}
                          </p>
                        }
                        @if (item?.linkUrl) {
                          <a class="text-link text-info"
                            (click)= "navigateRoutes(item?.linkUrl)">
                            {{ item?.linkText }}
                          </a>
                        }
                        @for (subItem of item.subItems; track subItem) {
                          <ul class="sub-items">
                            <li class="sub-items-item">{{ subItem.name }}</li>
                          </ul>
                        }
                      </div>
                    </div>
                  }
                  @if (removedNotCoverageItems?.length > 0) {
                    <a
                      class="showmore-link"
                      appAnalytics="click"
                      eventCategory="NAVBAR"
                      eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
                      eventLabel= "{{ProductName }} {{'- (What\'s Not Covered) - See more'}}"
                      (click)="loadMoreNotCoveredItems()">
                      Show more
                    </a>
                  }
                </div>
              </div>
            </div>
          }
          @if (endorsement) {
            <div class="container mobile-covered">
              <div class="covered-container" >
                <img
                  src="../../../assets/img/marketing/icons/not-covered-desktop.svg"
                  alt="cross"
                  class="covered-container-close"
                  appAnalytics="click"
                  eventCategory="NAVBAR"
                  eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
                  eventLabel= "{{ProductName }} {{'- (What\'s Not Covered) - Close'}}"
                  (click)="hideCoverage()">
                  <p class="covered-container-productname">{{ ProductName | uppercase}}</p>
                  <h2 class="covered-container-title">
                    What's covered by endorsement
                  </h2>
                  <div class="table-header">
                    <div class="table-header-title">Navigate to</div>
                    <div class="table-header-title">Link to endorsement</div>
                  </div>
                  <div class="flex-table-rows">
                    @for (item of endorsementItems; track item) {
                      <div class="group-row">
                        <div class="group-row-section">
                          <p class="text-info"><b>{{ item?.incidentName}}</b></p>
                        </div>
                        <div class="group-row-section">
                          <p class="text-info">{{ item?.textOne }}</p>
                          @if (item?.textOne) {
                            <p class="text-info">{{ item?.textTwo }}</p>
                          }
                          @if (item?.textThree) {
                            <p class="text-info">{{ item?.textThree }}</p>
                          }
                          @for (info of item.incidentInfo; track info) {
                            <p class="text-info">
                              {{ info.name }}
                            </p>
                          }
                          @if (item?.linkUrl) {
                            <a class="text-link text-info"
                              (click)= "navigateRoutes(item?.linkUrl)">
                              {{ item?.linkText }}
                            </a>
                          }
                          @for (subItem of item.subItems; track subItem) {
                            <ul class="sub-items">
                              <li class="sub-items-item">{{ subItem.name }}</li>
                            </ul>
                          }
                        </div>
                      </div>
                    }
                    @if (removedEndorsementItems?.length > 0) {
                      <a
                        class="showmore-link"
                        appAnalytics="click"
                        eventCategory="NAVBAR"
                        eventAction="NAVBAR_EXPLORE_COVERAGE_CLICK"
                        eventLabel= "{{ProductName }} {{'- (What\'s Covered by Endorsement) - See more'}}"
                        (click)="loadMoreEndorsementItems()">
                        Show more
                      </a>
                    }
                  </div>
                </div>
              </div>
            }

